<template>
  <div>
    <iModal
      title="添加人员"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="500px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="100"
            @submit.native.prevent
          >
            <FormItem label="人员类型：" prop="groupName">
              <Select v-model="formInline.groupName" placeholder="请选择人员类型">
                <Option v-for="(item,index) in groupList" :value="item.description" :key="index">{{ item.description }}</Option>
              </Select>
            </FormItem>
            <FormItem label="负责项目："> 
              <Input v-model="formInline.worker" placeholder="请输入负责项目" />
            </FormItem>
            <FormItem label="姓名："> 
              <Input v-model="formInline.name" placeholder="请输入姓名" />
            </FormItem>
            <FormItem label="Tel："> 
              <Input v-model="formInline.tel" placeholder="请输入联系方式" />
            </FormItem>
            <FormItem label="Email："> 
              <Input type="textarea" :rows="5" v-model="formInline.email" placeholder="请输入邮箱" />
            </FormItem>
            <FormItem label="显示顺序：">
              <InputNumber :max="9999" :min="0" v-model="formInline.showIndex"></InputNumber>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "label-add",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    groupList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      loading: false,
      showModal: false,
      formInline: {
        // form双向绑定
        groupName: "",
        worker: "",
        name: "",
        tel: "",
        email: "",
        showIndex: 0
      },
      ruleInline: {
        groupName: [{ required: true, message: "人员类型不能为空", trigger: "change" }],
      },
    };
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  created() {},
  methods: {
    ...mapActions({
      addContactUs: "hostCommonModule/addContactUs"
    }),
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {
        GroupName: form.groupName,
        Worker: form.worker,
        Name: form.name,
        Tel: form.tel,
        Email: form.email,
        ShowIndex: form.showIndex
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let bool = await this.addContactUs(req).catch(err => {
        this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("添加失败，请重新尝试");
      } else {
        this.$emit("finish");
        this.$Message.success("添加成功！");
        this.cancel();
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.formInline = {
        groupName: "",
        worker: "",
        name: "",
        tel: "",
        email: "",
        showIndex: 0
      }
      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

